import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/type-light.svg
 */
const IconTypeLight: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12.004.001a8.18 8.18 0 00-8.306 7.943 10.181 10.181 0 002.167 6.226 6.729 6.729 0 011.828 3.973v3.69A2.166 2.166 0 009.859 24h4.305a2.165 2.165 0 002.166-2.167v-3.69a6.747 6.747 0 011.805-3.973 10.152 10.152 0 002.167-6.226A8.18 8.18 0 0012.004.001zm0 1.844a6.339 6.339 0 016.46 6.103 8.034 8.034 0 01-1.828 5.16 9.811 9.811 0 00-2.093 4.114H9.469a9.814 9.814 0 00-2.095-4.113 8.015 8.015 0 01-1.826-5.161 6.336 6.336 0 016.456-6.087v-.016zm-1.444.922a1.545 1.545 0 00-.412.05 6.14 6.14 0 00-3.882 4.669.965.965 0 00.748 1.084.974.974 0 001.082-.758 4.295 4.295 0 012.709-3.269.953.953 0 00.585-1.028.827.827 0 00-.838-.733l.008-.015zm-1.008 16.3h4.922v.613H9.552v-.613zm0 2.46h4.922v.306a.294.294 0 01-.31.307H9.859a.295.295 0 01-.307-.307v-.307z"
      fill="currentColor"
    />
  </svg>
);

export default IconTypeLight;
